<template>
  <v-app>
    <!-- // também mudar a versão no webpack.prod.conf.js -->
    <input type="hidden" id="system_version" value="46"/>
    <!-- // Caso ainda não esteja carregado ou o usuário acabou de registrar e precisa esperar carregar todos os dados, insere um loader -->
    <v-content v-if="!$auth.ready() || ($auth.check() && !$auth.user().company)">
      <v-container fluid fill-height class="background">
        <v-layout align-center justify-center>
          <v-progress-circular indeterminate :width="5" color="white"></v-progress-circular>
        </v-layout>
      </v-container>
    </v-content>
    <v-content v-else>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<style>
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
  }

  /* coloca o overflow auto para so aparecer a barra de rolagem na página quando precisar */
  /* html, body {
    max-width: 100%;
    overflow: auto !important;
  } */
  /* Inicio Barra de rolagem */
  /* width */
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background: #ddd;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #999;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #bbb;
  }
  /* Fim Barra de rolagem */

  .background {
    background: -moz-linear-gradient(45deg, rgba(75, 151, 205, 1) 0%, rgba(95, 191, 141, 1) 100%); /* ff3.6+ */
    background: -webkit-gradient(linear, left bottom, right top, color-stop(0%, rgba(75, 151, 205, 1)), color-stop(100%, rgba(95, 191, 141, 1))); /* safari4+,chrome */
    background: -webkit-linear-gradient(45deg, rgba(75, 151, 205, 1) 0%, rgba(95, 191, 141, 1) 100%); /* safari5.1+,chrome10+ */
    background: -o-linear-gradient(45deg, rgba(75, 151, 205, 1) 0%, rgba(95, 191, 141, 1) 100%); /* opera 11.10+ */
    background: -ms-linear-gradient(45deg, rgba(75, 151, 205, 1) 0%, rgba(95, 191, 141, 1) 100%); /* ie10+ */
    background: linear-gradient(45deg, rgba(75, 151, 205, 1) 0%, rgba(95, 191, 141, 1) 100%); /* w3c */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#5fbf8d', endColorstr='#4b97cd', GradientType=1); /* ie6-9 */
  }
</style>

<script>
  export default {
    name: 'App',
    created () {
      // Caso em algum momento não estej preparado e não tenho usuário logado, espera 10 segundos, caso continue atualiza a pagina e limpa o cache(true)
      if (!this.$auth.ready() && !this.$auth.check()) {
        setTimeout(() => {
          if (!this.$auth.ready() && !this.$auth.check()) {
            this.$auth.logout()
            setTimeout(() => {
              window.location.reload(true)
            }, 2000)
          }
        }, 10000)
      }
      if (!navigator.onLine) {
        this.$router.push('/offline')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue